import { Button } from "@omni/ui/components/Button/button.component";
import classnames from "classnames";
import { ReactNode, useEffect } from "react";

import {
    Message,
    MessagePostFix
} from "@/redux/modules/value/messages/messages.utils";
import { ScrollOffsets } from "@/utils/enums";
import { scrollToElementById } from "@/utils/scroll";

import "./messages.scss";
import { Alert } from "@omni/ui/components/Alert/alert.component";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export type MessageComponentProps = {
    message: Message;
    clearById?: (id: string) => void;
    className?: string;
};

const MessageComponent = ({
    message,
    clearById,
    className
}: MessageComponentProps) => {
    const { t } = useGranite();
    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        const { activeScroll = true, id } = message;

        if (activeScroll) {
            setTimeout(() => {
                scrollToElementById(id, ScrollOffsets.DEFAULT, true);
            }, 300);
        }
    }, []);

    const addPostFix = (postFix?: MessagePostFix): null | ReactNode => {
        if (!postFix) {
            return null;
        }

        return (
            <Button
                color="link"
                onClick={postFix.onClick}
                className={cn("tw:py-0! tw:leading-3!")}
            >
                {postFix.text}
            </Button>
        );
    };

    return (
        <div
            tabIndex={-1}
            className="messages__message-wrapper"
            id={message.id}
        >
            <Alert
                color={message.status}
                className={className}
                closeAriaLabel={t("general.alert.close")}
                isOpen={true}
                toggle={
                    message.dismissible
                        ? () => clearById?.(message.id)
                        : undefined
                }
            >
                {message.title && (
                    <h4 className={classnames("alert-heading")}>
                        {message.title}
                    </h4>
                )}
                <span
                    dangerouslySetInnerHTML={{
                        __html: message.text
                    }}
                />
                {addPostFix(message.postFix)}
            </Alert>
        </div>
    );
};

export { MessageComponent };
